import {z} from 'zod';

/**
 * Response schema for getting original file as base64 from storage service
 */
export const storageOriginalFileResponseSchema = z.object({
  base64: z.string(),
  contentType: z.string(),
  size: z.number().int().nonnegative(),
  filename: z.string().optional(),
});

export type StorageOriginalFileResponse = z.infer<typeof storageOriginalFileResponseSchema>;
